import React, { useState } from 'react';
import axios from 'axios';

export const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');

    try {
      await axios.post('/api/subscribe', { email });
      setStatus('success');
      setEmail('');
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="bg-gradient-to-r from-purple-900 to-indigo-900 py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Join the Enlightened
          </h2>
          <p className="mt-4 text-lg leading-8 text-gray-300">
            Get exclusive insights and wisdom delivered directly to your inbox.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="mt-10 max-w-md mx-auto">
          <div className="flex gap-x-4">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="min-w-0 flex-auto rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-purple-500 sm:text-sm sm:leading-6"
              placeholder="Enter your email"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="flex-none rounded-md bg-purple-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-500 disabled:opacity-50"
            >
              Subscribe
            </button>
          </div>
          {status === 'success' && (
            <p className="mt-4 text-sm text-green-400">Thank you for subscribing!</p>
          )}
          {status === 'error' && (
            <p className="mt-4 text-sm text-red-400">Something went wrong. Please try again.</p>
          )}
        </form>
      </div>
    </div>
  );
};